import React, { useEffect, useState } from 'react';
import { Grid, CircularProgress, Box } from '@mui/material';

// Services
import { getTermsAndPrivacyContent } from '../../../services/NetworkServices';
import ApiStatus from '../../../config/apiStatusConstants';
import { getRole } from '../../../utils/auth-token-utils/cookie';

// Components
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import TopNav from '../../../components/TopNav/TopNav';
import Description from '../../../components/Description/Description';

import { getSx } from './style';

const BabysitterPrivacyPolicy = () => {
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [apiStatus, setApiStatus] = useState<ApiStatus>(ApiStatus.INITIAL);
  const role = getRole();
  const styles = getSx();

  useEffect(() => {
    const fetchTermsAndConditionsContent = async () => {
      const type = 'PRIVACY_POLICY';
      setApiStatus(ApiStatus.LOADING);
      const response = await getTermsAndPrivacyContent({ type: type, role });
      const data = await response.data;
      if (data) {
        setApiStatus(ApiStatus.SUCCESS);
        setTitle(data.data.content[0].title);
        setDescription(data.data.content[0].description);
      }
    };
    fetchTermsAndConditionsContent();
  }, []);

  return (
    <StyledBgContainer>
      <TopNav showArrow={true} />
      {apiStatus === ApiStatus.LOADING && (
        <Box sx={styles.spineWrapper}>
          <CircularProgress size={20} />
        </Box>
      )}
      {apiStatus === ApiStatus.SUCCESS && (
        <Grid container sx={styles.container}>
          <h1 className="heading">Privacy Policy</h1>
          <Description>{title}</Description>
          <Grid item xs={12} sx={styles.content}>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </Grid>
        </Grid>
      )}
    </StyledBgContainer>
  );
};

export default BabysitterPrivacyPolicy;
